import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import './style.css';

class PrivateRoute extends React.Component {

  render() {
    const { component: Component, authenticate, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={props => {
          if (authenticate) {
            return <Component {...props} />
          } else {
            return <Redirect to={
              {
                pathname: "/login",
                state: {
                  from: props.location
                }
              }
            } />
          }
        }
        } />
    )
  }
}

export default PrivateRoute;
